import { useGetAccommodations } from "@/hooks/accommodations";
import { useGetReservationClients } from "@/hooks/reservation-clients";
import { useGetReservationDays } from "@/hooks/reservation-days";
import { useGetReservationServices } from "@/hooks/reservation-services";
import { useGetReservation } from "@/hooks/reservations";
import { useMemo } from "react";

export function useGetFullReservation(reservationId: string) {
  const { data: reservation, isLoading: reservationLoading } =
    useGetReservation(reservationId);
  const { data: accommodations, isLoading: accommodationsLoading } =
    useGetAccommodations(reservationId);
  const { data: services, isLoading: servicesLoading } =
    useGetReservationServices(reservationId);

  const { data: days, isLoading: daysLoading } =
    useGetReservationDays(reservationId);
  const { data: clients, isLoading: clientsLoading } =
    useGetReservationClients(reservationId);

  const isLoading = useMemo(
    () =>
      reservationLoading ||
      accommodationsLoading ||
      servicesLoading ||
      daysLoading ||
      clientsLoading,
    [
      accommodationsLoading,
      clientsLoading,
      daysLoading,
      reservationLoading,
      servicesLoading,
    ],
  );

  const data = useMemo(
    () => ({
      reservation,
      accommodations,
      services,
      days,
      clients,
    }),
    [accommodations, clients, days, reservation, services],
  );

  return useMemo(() => ({ data, isLoading }), [data, isLoading]);
}
